import { Button, Dialog, Heading } from '@expressable/syntax-ds';
import { useTranslation } from 'react-i18next';
import { routes } from 'router/routes';
import { useNavigation } from 'utils/hooks/useNavigation';

export type NoAppointmentsDialogProps = {
  isOpen: boolean;
  onDismiss: () => void;
};

export const NoAppointmentsDialog: React.FC<NoAppointmentsDialogProps> = ({ isOpen, onDismiss }) => {
  const { t } = useTranslation();
  const { navigate } = useNavigation();

  return (
    <Dialog isOpen={isOpen} onDismiss={onDismiss}>
      <Dialog.Body>
        <Heading level="h3">
          {t('rescheduleDirect.init.noAppointmentsDialog.title', "Can't find an appointment?")}
        </Heading>
        <Dialog.Description>
          {t('rescheduleDirect.init.noAppointmentsDialog.subtitle')}
        </Dialog.Description>
      </Dialog.Body>
      <Dialog.CTAs>
        <Button variant="primary" size="md" type="button" onClick={() => navigate(routes.openSupportCase)}>
          {t('rescheduleDirect.init.noAppointmentsDialog.openSupportCase')}
        </Button>
        <Button variant="secondary" size="md" type="button" onClick={() => onDismiss()}>
          {t('rescheduleDirect.init.noAppointmentsDialog.cancel')}
        </Button>
      </Dialog.CTAs>
    </Dialog>
  );
};

